export default __webpack_public_path__ + "static/media/DiceFanatics.e9b6e026.png";